import { defaultHttpClient } from 'shared/src/api/httpClient';

export const postBookmarkOutfit = (sno: number) => {
  return defaultHttpClient
    .request<void>({
      method: 'POST',
      url: `/api/v2/outfits/${sno}/bookmark/`,
    })
    .then(result => result.data);
};
